import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-advertiser-billing-info',
  templateUrl: './advertiser-billing-info.component.html'
})
export class AdvertiserBillingInfoComponent implements OnInit {
  @Input("form") form: FormGroup;
  constructor() { }

  ngOnInit() {
    
  }

}
